module.exports = __webpack_public_path__ + "static/img/tpLogo.8bb61f34.png";